import postData from '../assets/js/fetch.js'
import router from '../router'

let dev
process.env.NODE_ENV === 'production' ? (dev = '') : (dev = 'https://apps.icnea.net')

const state = {
    loginUrl: '',
    user: '',
    translator: '',
    empresa: '',
    paisos: [],
}

const mutations = {
    setLogin(state, loginUrl) {
        state.loginUrl = loginUrl
    },
    setUser(state, user) {
        state.user = user
    },
    setTranslator(state, translator) {
        state.translator = translator
    },
    setEmpresa(state, empresa) {
        state.empresa = empresa
    },
    setPaisos(state, paisos) {
        state.paisos = paisos
    },
}

const actions = {
    getLogin({commit}, {usr, email, contrasenya, iniSesion, vm, msn}) {
        postData(dev + '/WebService.asmx/Login', {usr, email, contrasenya}).then((data) => {
            if (data.d != '') {
                const url = new URL(data.d)
                iniSesion ? localStorage.setItem('iniSesion', url) : null
                router.push(`${url.pathname}${url.search}`)
            } else {
                vm.$toast.error(msn)
            }

            console.log('Login', data.d)
            commit('setLogin', data.d)
        })
    },

    getUser({commit}, {usr}) {
        postData(dev + '/WebService.asmx/Usuari', {usr}).then((data) => {
            const response = JSON.parse(data.d).Response || {}
            // Some error payloads do not include owner_block, so provide a safe default.
            response.owner_block = response.owner_block || ''

            console.log('Usuari', response)
            const lang = response.user_language || 2

            commit('setUser', response)
            sessionStorage.setItem('user', JSON.stringify(response))

            if (sessionStorage.getItem('diccionario') == undefined) {
                postData(dev + '/WebService.asmx/Diccionari', {
                    usr,
                    idioma: lang || 2,
                }).then((data) => {
                    console.log('Diccionari', JSON.parse(data.d).Diccionari)
                    sessionStorage.setItem('diccionario', JSON.stringify(JSON.parse(data.d).Diccionari))
                    commit('setTranslator', JSON.parse(data.d).Diccionari)
                })
            } else {
                commit('setTranslator', JSON.parse(sessionStorage.getItem('diccionario')))
            }
        })
    },

    getTranslator({commit}, {usr, lang}) {
        if (usr === undefined) {
            console.log('No user')
            return
        }

        postData(dev + '/WebService.asmx/Diccionari', {
            usr,
            idioma: lang || 2,
        }).then((data) => {
            console.log('Diccionari', JSON.parse(data.d).Diccionari)
            sessionStorage.setItem('diccionario', JSON.stringify(JSON.parse(data.d).Diccionari))
            commit('setTranslator', JSON.parse(data.d).Diccionari)
        })
    },
    getEmpresa({commit}, {usr}) {
        postData(dev + '/WebService.asmx/Empresa', {usr}).then((data) => {
            console.log('Empresa', data.d)
            commit('setEmpresa', data.d)
        })
    },
    getPaisos({commit}, {usr}) {
        postData(dev + '/WebService.asmx/Paisos', {usr}).then((data) => {
            const JsonPaisos = JSON.parse(data.d).Response
            console.log('Paisos', JsonPaisos.countries)
            commit('setPaisos', JsonPaisos.countries)
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
